import { Dialog, DialogContent, DialogTitle, Grid, MenuItem, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import FilterSelect from '../select/filterSelect'
import InputDatePicker from '../input/inputDatePicker'
import moment from 'moment'
import InputTextField from '../input/inputTextField'
import ButtonCustom from '../button/buttonCustom'
import { useNavigate } from 'react-router-dom'
import ClearIcon from '@mui/icons-material/Clear';
import AutocompleteSelect from '../select/autoCompleteSelect'
import FolderApi from '../../api/folder/folder.api'
import DepartmentApi from '../../api/departments/departments.api'

type Prop = {
    open?: any
    handleClose?: any
}

export default function AdvanceSearch(props: Prop) {
    const { open, handleClose } = props
    const navigate = useNavigate()
    const [sdate, setSdate] = useState<string>('');
    const [ddate, setDdate] = useState<string>('');
    const [edate, setEdate] = useState<string>('');
    const [keyword, setKeyword] = useState<string>('');
    const [keywordIndex, setKeywordIndex] = useState<string>('');
    const [keywordLevel1, setKeywordLevel1] = useState<string>('');
    const [keywordLevel2, setKeywordLevel2] = useState<string>('');
    const [keywordLevel3, setKeywordLevel3] = useState<string>('');
    const [keywordLevel4, setKeywordLevel4] = useState<string>('');
    const [keywordLevel1v, setKeywordLevel1v] = useState<any>();
    const [keywordLevel2v, setKeywordLevel2v] = useState<any>();
    const [keywordLevel3v, setKeywordLevel3v] = useState<any>();
    const [keywordLevel4v, setKeywordLevel4v] = useState<any>();
    const [idDocumentType, setIdDocumentType] = useState<number>();
    const [documentType, setDocumentType] = useState<any>([]);
    const [fileLocation, setFileLocation] = useState<string>('');
    const [folderLocation, setFolderLocation] = useState<string>('');
    const [idSearchType, setIdSearchType] = useState<string>('');
    const [folderName, setFolderName] = useState<any>([]);
    const [idFiscalYear, setIdFiscalYear] = useState<number>();

    const loadFolderName = async () => {
        const res = await FolderApi.getFolderName()
        const data = await res.data;
        if (data?.success) {
            setFolderName(data.result)
        }
    }
    const getDocumentType = async () => {
        const res = await FolderApi.getDocumentType()
        const data = res.data
        if (data?.success) {
            setDocumentType(data.result)
        }
    }
    useEffect(() => {
        loadFolderName()
        getDocumentType()
    }, [])
    const clearState = () => {
        setDdate('')
        setEdate('')
        setSdate('')
        setIdDocumentType(0)
        setKeyword('')
        setKeywordIndex('')
        setKeywordLevel1('')
        setKeywordLevel1v(null)
        setKeywordLevel2v(null)
        setKeywordLevel3v(null)
        setKeywordLevel4v(null)
        setKeywordLevel2('')
        setKeywordLevel3('')
        setKeywordLevel4('')
        setFileLocation('')
        setFolderLocation('')
    }
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth='lg'
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px" }} onClick={() => {
                    handleClose()
                    clearState()
                }} />
            </DialogTitle>
            <DialogContent>
                <Grid container sx={{ marginBottom: "20px" }} spacing={2}>
                    <Grid item md={2} xs={12}>
                        <FilterSelect heading='ประเภทการค้นหา' labelId='' selectId='' options={
                            [
                                {
                                    idSearchType: 'BOTH',
                                    searchType: 'ทั้งหมด'
                                },
                                {
                                    idSearchType: 'FILE',
                                    searchType: 'ไฟล์เอกสาร'
                                },
                                {
                                    idSearchType: 'FOLDER',
                                    searchType: 'ตู้เอกสาร'
                                },
                            ].map((x: any, i: number) => {
                                return (
                                    <MenuItem key={i}
                                        value={x.idSearchType}
                                    >
                                        {x.searchType}
                                    </MenuItem>
                                )
                            }
                            )} value={idSearchType} onchange={(e: any) => { setIdSearchType(e.target.value) }} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <FilterSelect heading='ประเภทไฟล์' labelId='' selectId='' options={
                            documentType.map((x: any, i: number) => {
                                return (
                                    <MenuItem key={i}
                                        value={x.idDocumentType}
                                    >
                                        {x.documentType}
                                    </MenuItem>
                                )
                            }
                            )} value={idDocumentType} onchange={(e: any) => { setIdDocumentType(e.target.value) }} />
                    </Grid>
                </Grid>

                <Grid container sx={{ marginBottom: "20px" }} spacing={2}>
                    <Grid item md={2.5} xs={12}>
                        <InputDatePicker
                            dateFormat="DD/MM/YYYY"
                            required={false}
                            key={""}
                            disabled={false}
                            label=""
                            value={sdate}
                            onClear={() => setSdate('')}
                            onChange={(e: any) => setSdate(moment(e).format("YYYY-MM-DD"))
                            }
                            allowClear
                            heading={'ตั้งแต่วันที่'} />
                    </Grid>
                    <Grid item md={2.5} xs={12}>
                        <InputDatePicker
                            dateFormat="DD/MM/YYYY"
                            required={false}
                            key={""}
                            disabled={false}
                            label=""
                            value={edate}
                            onClear={() => setEdate('')}
                            onChange={(e: any) => setEdate(moment(e).format("YYYY-MM-DD"))
                            }
                            allowClear
                            heading={'ถึงวันที่'} />
                    </Grid>
                </Grid>
                <Grid container sx={{ marginBottom: "20px" }} spacing={2}>
                    <Grid item md={6} xs={12}>
                        <InputTextField heading='ชื่อรายการ (ป้อนคำที่เป็นส่วนหนึ่งของชื่อเอกสาร)' value={keyword} onchange={(e: any) => setKeyword(e.target.value)} />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <InputTextField heading='ชื่อดัชนี' value={keywordIndex} onchange={(e: any) => setKeywordIndex(e.target.value)} />
                    </Grid>
                </Grid>
                <Grid container sx={{ marginBottom: "20px" }} spacing={2}>
                    <Grid item md={6} xs={12}>
                        <AutocompleteSelect
                            options={folderName?.level1}
                            // disabled={location.state.params.isView}
                            getOptionLabel={(option: any) => option}
                            labelId="addmin-type"
                            inputValue={keywordLevel1}
                            value={keywordLevel1v}
                            onChange={(event, newValue) => {
                                setKeywordLevel1v(newValue)
                            }}
                            heading={'ตู้เอกสาร/หน่วยงาน'}
                            placeholder='ทั้งหมด'
                            onInputChange={(event, newValue) => {
                                setKeywordLevel1(newValue)
                            }}
                            // required
                            helperText={''}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <AutocompleteSelect
                            options={folderName?.level2}
                            // disabled={location.state.params.isView}
                            getOptionLabel={(option: any) => option}
                            labelId="addmin-type"
                            inputValue={keywordLevel2}
                            value={keywordLevel2v}
                            onChange={(event, newValue) => {
                                setKeywordLevel2v(newValue)
                            }}
                            heading={'ชื่อชั้นเอกสาร'}
                            placeholder='ทั้งหมด'
                            onInputChange={(event, newValue) => {
                                setKeywordLevel2(newValue)
                            }}
                            // required
                            helperText={''}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ marginBottom: "20px" }} spacing={2}>
                    <Grid item md={6} xs={12}>
                        <AutocompleteSelect
                            options={folderName?.level3}
                            // disabled={location.state.params.isView}
                            getOptionLabel={(option: any) => option}
                            labelId="addmin-type"
                            inputValue={keywordLevel3}
                            value={keywordLevel3v}
                            onChange={(event, newValue) => {
                                setKeywordLevel3v(newValue)
                            }}
                            heading={'แฟ้มเอกสาร'}
                            placeholder='ทั้งหมด'
                            onInputChange={(event, newValue) => {
                                setKeywordLevel3(newValue)
                            }}
                            // required
                            helperText={''}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <AutocompleteSelect
                            options={folderName?.level4}
                            // disabled={location.state.params.isView}
                            getOptionLabel={(option: any) => option}
                            labelId="addmin-type"
                            inputValue={keywordLevel4}
                            value={keywordLevel4v}
                            onChange={(event, newValue) => {
                                setKeywordLevel4v(newValue)
                            }}
                            heading={'ชื่อประเภทเอกสาร'}
                            placeholder='ทั้งหมด'
                            onInputChange={(event, newValue) => {
                                setKeywordLevel4(newValue)
                            }}
                            // required
                            helperText={''}
                        />
                    </Grid>
                </Grid>
                <Typography sx={{ marginBottom: '20px' }}>ตำแหน่งที่เก็บเอกสารจริง</Typography>
                <Grid container sx={{ marginBottom: "20px" }} spacing={2}>
                    <Grid item md={6} xs={12}>
                        <InputTextField heading='ตู้ที่จัดเก็บ' value={folderLocation} onchange={(e) => setFolderLocation(e.target.value)} />

                    </Grid>
                    <Grid item md={6} xs={12} >
                        <InputTextField heading='ตำแหน่งไฟล์' value={folderLocation} onchange={(e) => setFolderLocation(e.target.value)} />
                    </Grid>
                </Grid>

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <ButtonCustom variant={'outlined'}
                        textButton={'คืนค่า'}
                        style={{ marginRight: '8px' }}
                        onClick={() => {
                            clearState()
                        }} />
                    <ButtonCustom variant={'outlined'}
                        textButton={'ค้นหา'}
                        onClick={() => {
                            navigate('/search-results', {
                                state: {
                                    sdate: sdate,
                                    edate: edate,
                                    keyword: keyword,
                                    keywordIndex: keywordIndex,
                                    keywordLevel1: keywordLevel1,
                                    keywordLevel1v: keywordLevel1v,
                                    keywordLevel2: keywordLevel2,
                                    keywordLevel2v: keywordLevel2v,
                                    keywordLevel3: keywordLevel3,
                                    keywordLevel3v: keywordLevel3v,
                                    keywordLevel4: keywordLevel4,
                                    keywordLevel4v: keywordLevel4v,
                                    fileLocation: fileLocation,
                                    folderLocation: folderLocation,
                                    idDocumentType: idDocumentType,
                                    idSearchType: idSearchType
                                }
                            })
                            clearState()
                            handleClose()
                        }}
                        btnStyle={{
                            '&.MuiButton-outlined': {
                                color: `#fff !important`,
                                width: '90px',
                                border: `2px solid #026735 !important`,
                                borderRadius: "10px !important",
                                backgroundColor: '#026735 !important',
                                '&:hover': {
                                    color: `#fff  !important`,
                                    border: `2px solid #026735 !important`,
                                    backgroundColor: '#026735 !important'
                                },
                            },
                        }} />
                </div>
            </DialogContent>
        </Dialog>
    )
}
